<template>
    <b-list-group flush>
        <b-modal id="aboutDatasetModal" hide-footer title="Prepared data sets">
            <ul>
                <li>Cars<a href="/datasets/cars.csv">
                    <icon name="anchor"></icon>
                </a></li>
                <li>Iris<a href="/datasets/iris.csv">
                    <icon name="anchor"></icon>
                </a>
                </li>
            </ul>
        </b-modal>
        <b-list-group-item>
            <p class="card-text" title="Displayed data">
                <em>{{ message }}</em>
            </p>
        </b-list-group-item>
        <b-form @submit="onSubmit">
            <b-list-group-item>
                <b-form-group label="Predefined data sets" label-for="select-dataset">
                    <b-form-select id="select-dataset"
                                   placeholder="Select a predefined data sets"
                                   :options="datasetPossibilities"
                                   v-model="form.input.dataset"
                                   v-on:input="selectedDataset($event)">
                    </b-form-select>
                    <b-form-text>
                        Detail on prepared datasets
                        <b-link class="icon-button" v-b-modal.aboutDatasetModal>
                            <font-awesome-icon icon="info-circle"/>
                        </b-link>
                    </b-form-text>
                </b-form-group>
                <b-form-group v-on:input="selectedFile($event)">
                    <upload-modal></upload-modal>
                </b-form-group>
            </b-list-group-item>
            <b-list-group-item>
                <b-form-group :disabled="isLoading || !datasetSelected">
                    <b-form-checkbox v-model="form.processing.useClustering" id="useClustering">Cluster each
                        dimension
                    </b-form-checkbox>
                </b-form-group>
                <b-form-group v-if="form.processing.useClustering"
                              label="Clustering type:"
                              label-for="clustering-choice-input"
                              :disabled="isLoading || !datasetSelected">
                    <b-form-select id="clustering-choice-input"
                                   :options="clusteringPossibilities"
                                   v-model="form.processing.clustering">
                    </b-form-select>
                </b-form-group>

                <b-form-group v-if="form.processing.useClustering"
                              label="Number of cluster per dimension:"
                              label-for="clustering-choice-input"
                              :disabled="isLoading || !datasetSelected">
                    <b-form-input v-if="form.processing.useClustering"
                                  id="clustering-number"
                                  type="number"
                                  :state="nbClusterState"
                                  aria-describedby="nbClusterFeedback"
                                  v-model=form.processing.nbClusters>
                    </b-form-input>
                    <b-form-invalid-feedback id="nbClusterFeedback">
                        Invalid number of clusters.
                    </b-form-invalid-feedback>
                    <b-form-text id="inputLiveHelp">
                        Choose a number of clusters per-dimension between 2 and 50.
                    </b-form-text>
                </b-form-group>
                <b-button :disabled="!nbClusterState || !datasetSelected" block type="submit"
                          variant="primary">
                    <font-awesome-icon :hidden="!isLoading" icon="spinner" spin
                                       class="mr-2"></font-awesome-icon>
                    {{ launchMessage }}
                </b-button>
            </b-list-group-item>
        </b-form>
    </b-list-group>
</template>

<script>
    import {mapGetters} from "vuex";
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import UploadModal from "./UploadModal";

    const datasets = require('@/assets/datasets.json');
    const clusterings = require('@/assets/clusterings.json');

    export default {
        name: "ImportForm",
        components: {
            UploadModal,
            FontAwesomeIcon
        },
        data() {
            return {
                clusterings,
                datasets,
                message: 'Please select or upload a dataset.',
                isLoading: false,
                isInit: true,
                form: {
                    input: {
                        dataset: null,
                        file: null // Custom data
                    },
                    options: {},
                    processing: {
                        useClustering: true, // TODO ensure coherent with core (use store?)
                        clustering: clusterings.binning.id,
                        nbClusters: 10
                    }
                }
            };
        }, computed: {
            launchMessage() {
                return this.isInit ? 'Load' : 'Update';
            },
            nbClusterState() {
                return (this.form.processing.nbClusters >= 2 && this.form.processing.nbClusters <= 50);
            },
            datasetSelected() {
                return this.form.input.dataset !== null || this.form.input.file !== null;
            },
            datasetPossibilities() {
                return Object.keys(this.datasets).map(k => {
                    return {text: this.datasets[k].name, value: k};
                });
            },
            clusteringPossibilities() {
                return Object.values(this.clusterings).filter(e => e.arg).map(e => {
                    return {text: e.name, value: e.id};
                });
            },
            // mix the getters into computed with object spread operator
            ...mapGetters(['loadingProgress'])
        },
        methods: {
            selectedDataset(datasetName) {
                this.form.input.file = null
                this.form.options = datasets[datasetName];
            },
            selectedFile(fileAndOptions) {
                this.form.input.file = fileAndOptions.file
                this.form.options = fileAndOptions.options
                this.form.input.dataset = null
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.isLoading = true;
                this.$store.dispatch('loadDataset', this.form)
                    .then(() => {
                        this.isLoading = false;
                        this.message = this.$store.getters.dataSummary;
                        this.isInit = false;
                    }, error => {
                        console.error(error); // TODO Visual message
                        this.message = "Loading error:" + error

                    }).catch(e => console.error(e));
            },

        }
    };
</script>

<style scoped>

</style>
